'use strict';

var _ = require('lodash');
var RenormalizeEffectiveValueService = function RenormalizeEffectiveValueService(overrideUtils, effectiveValService, constants, configurationService, featureToggleService, directForecastingConfigurationService) {
  var RENORMALIZE_SUM = 1;
  var FIELDS = _.chain(constants.FIELDS_TO_RENORMALIZE).map(function (item) {
    return {
      user: item,
      effective: overrideUtils.getEffectiveFieldName(item),
      model: overrideUtils.getRootFieldName(item)
    };
  }).keyBy('user').value();
  function getKey(row) {
    return [row.market, row.classGroup, row.departureDate, row.significantPOS].join('-');
  }
  function findAffectedRows(wholeGridData, row, colName) {
    if (_.isUndefined(colName) || _.includes(constants.FIELDS_TO_RENORMALIZE, colName)) {
      var filter = {
        market: row.market,
        classGroup: row.classGroup,
        departureDate: row.departureDate,
        significantPOS: row.significantPOS
      };
      return _.filter(wholeGridData, function (item, index) {
        if (_.isMatch(item, filter)) {
          item.originalRowId = index;
          return true;
        }
      });
    } else {
      return [];
    }
  }
  function validateUserShare(data) {
    var groups = _.groupBy(data, function (row) {
      return getKey(row);
    });
    var valid = true;
    _.forEach(groups, function (group) {
      _.forEach(FIELDS, function (field) {
        var sum = 0;
        for (var i = 0; i < group.length; i++) {
          sum += group[i][field.user] || 0;
        }
        if (_.floor(sum, 4) > RENORMALIZE_SUM) {
          valid = false;
          return false;
        }
      });
    });
    return valid;
  }
  function renormalizeAll(gridData) {
    var rowGroups = _.groupBy(gridData, function (row) {
      return getKey(row);
    });
    _.forEach(rowGroups, function (group) {
      _.forEach(FIELDS, function (item) {
        renormalize(group, item.user);
      });
    });
    return gridData;
  }
  function getModelSumValue(affectedRows, fieldNames) {
    return _.sumBy(affectedRows, function (element) {
      return _.isNil(element[fieldNames.user]) ? element[fieldNames.model] : 0;
    });
  }
  function renormalize(affectedRows, colName, edited) {
    var affectedColumns = [];
    if (_.includes(constants.FIELDS_TO_RENORMALIZE, colName)) {
      var fieldNames = FIELDS[colName];
      var sumOfUserValues = _.sumBy(affectedRows, fieldNames.user) || 0;
      var leftToDistribute = sumOfUserValues >= RENORMALIZE_SUM ? 0 : RENORMALIZE_SUM - sumOfUserValues;
      var leftModelSumValue = getModelSumValue(affectedRows, fieldNames);
      leftToDistribute = leftModelSumValue === 0 ? 0 : leftToDistribute;
      if (!_.isNil(leftModelSumValue)) {
        _.forEach(affectedRows, function (row) {
          var userValue = row[fieldNames.user];
          var modelValue = row[fieldNames.model];
          var effectiveValue;
          if (!_.isNil(userValue)) {
            effectiveValue = sumOfUserValues === 0 && leftModelSumValue === 0 ? RENORMALIZE_SUM / affectedRows.length : userValue / (sumOfUserValues + leftToDistribute) * RENORMALIZE_SUM;
            row[fieldNames.effective] = effectiveValue;
          } else if (!_.isNil(modelValue)) {
            effectiveValue = leftModelSumValue !== 0 ? modelValue / leftModelSumValue * leftToDistribute : 0;
            row[fieldNames.effective] = effectiveValue;
          }
          var dependencies = constants.RENORMALIZE_DEPENDENCIES[colName];
          if (dependencies !== undefined && !_.isNil(effectiveValue)) {
            _.forEach(dependencies, function (fieldName) {
              row[fieldName] = row[overrideUtils.getBaseFieldName(fieldName)] * effectiveValue / RENORMALIZE_SUM;
              affectedColumns.push(fieldName);
              var effectiveField = effectiveValService.getField(row, fieldName);
              if (effectiveField) {
                row[effectiveField.fieldName] = effectiveField.value;
                affectedColumns.push(effectiveField.fieldName);
              }
            });
          }
          if (edited && row._old === undefined) {
            row._old = {};
          }
        });
      }
    }
    return affectedColumns;
  }
  function shouldApplyRenormalization(services) {
    if (configurationService.isDemandDistributionIncremental()) {
      return false;
    }
    var service = _.first(services);
    if (!service || featureToggleService.isDisabled('DIRECT_FORECAST_ENABLE')) {
      return true;
    }
    return !directForecastingConfigurationService.isDirectForecastingMarket(service.origin, service.destination);
  }
  return {
    findAffectedRows: findAffectedRows,
    renormalize: renormalize,
    renormalizeAll: renormalizeAll,
    validateUserShare: validateUserShare,
    shouldApplyRenormalization: shouldApplyRenormalization
  };
};
RenormalizeEffectiveValueService.$inject = ['OverridesUtilsService', 'CalculateEffectiveValueService', 'OverridesConstants', 'ConfigurationService', 'FeatureToggleService', 'DirectForecastingConfigurationService'];
module.exports = RenormalizeEffectiveValueService;